
<template>
  <div :id="id" :class="className" :style="{ height, width }" />
</template>
  
<script lang="ts">
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick, watch,toRefs, reactive } from 'vue'
import i18n from "@/locales/index";
const _t = i18n.global.t;
import { init, EChartsOption } from 'echarts'
import { method } from 'lodash';
import { getLanguage } from "@/utils/cookies";
export default defineComponent({
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'echartsWorkTimeComponents'
    },
    width: {
      type: String,
      default: '100%',
      required: true
    },
    height: {
      type: String,
      default: '280px',
      required: true
    },
    chartsData: {
      type: Object,
      default: ''
    }
  },
  setup(props) {
 
    const state = reactive({
      graphic_left(){
        let language = getLanguage()
        if(language == 'en'){
          return '31.5%'
        }else if(language == 'zh-cn'){
          return '31.5%'
        }else if(language == 'ko'){
          return '30.5%'
        }else if(language == 'de'){
          return '29.5%'
        }else if(language == 'fr'){
          return '28%'
        }else if(language == 'ja'){
          return '31%' 
        }else if(language == 'nl'){
          return '28%'
        }else if(language == 'pl'){
          return '29.5%'
        }
      }
    })

    const initChart = () => {
      const getTimeChange = (time: any) => {
        if (isNaN(time)) return null
        const str = Math.floor(time / 60 / 60) + _t('home.hour') + Math.floor(time / 60 % 60) + _t('home.min')
        return str
      }
      const echartsWorkTime = init(document.getElementById(props.id) as HTMLDivElement)

      echartsWorkTime.setOption({
        tooltip: {
          trigger: 'item',
          valueFormatter: (value?: any) => getTimeChange(value),
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: '52%',
          y: '19%',
        },
        graphic: {
          type: 'text',     // 类型：文本
          left: state.graphic_left(),
          bottom: 10,
          silent: true,     // 不响应事件
          invisible: props.chartsData.length > 0,   // 有数据就隐藏
          style: {
            fill: 'rgba(0, 0, 0, 0.25)',
            fontWeight: 'bold',
            text: _t('system.noData'),
            fontFamily: 'Microsoft YaHei',
            fontSize: '14'
          }
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            center: ['35%', '50%'],
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 10,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: props.chartsData
          }
        ]
      } as EChartsOption)
    }


    watch(() => props, (newVal, oldVal) => {
      setTimeout(() => {
        initChart()
      }, 500)
    }, { deep: true })

    onMounted(() => {
      setTimeout(() => {
        initChart()
      }, 500)
    })

    onBeforeUnmount(() => {

    })

    onActivated(() => {

    })

    onDeactivated(() => {

    })

    return {
      ...toRefs(state)
    }
  }
})
</script>
  
<style scoped>
.chart {}
</style>
  